import { render, staticRenderFns } from "./SearchProposal.vue?vue&type=template&id=4fa89f91&scoped=true&"
import script from "./SearchProposal.vue?vue&type=script&lang=js&"
export * from "./SearchProposal.vue?vue&type=script&lang=js&"
import style0 from "./SearchProposal.vue?vue&type=style&index=0&id=4fa89f91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa89f91",
  null
  
)

export default component.exports